import { Component, OnInit } from '@angular/core';
import { PeopleService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';
import { StudentClass, Student, BaseCard, AwardEvent } from '@df/interfaces';
import { MatDialog } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AchievementsService } from '@app/results/services/achievements.service';
import { ActivatedRoute } from '@angular/router';
import { TournamentsService } from '@app/core/services/tournaments.services';

// :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

@Component({
    selector: 'app-awards',
    templateUrl: './awards.component.html',
    styleUrls: ['./awards.component.scss']
})
export class AwardsComponent implements OnInit {
    TOURNAMENT_EVENT_ID = 4;
    studentsClassId: number;
    selectedClass: StudentClass;
    dialogRef: any;
    students: Array<Student>;
    selectedAllStudents: boolean = false;
    isAwardSettings = true;
    isProfileAwards = false;
    isEditAward = false;
    selectedStudent: Student;
    eventAwards: Array<BaseCard> = [];
    choosesCard: BaseCard;
    form: FormGroup;
    filesLinks: Array<string> = [];
    awardEvents: Array<AwardEvent> = [];
    isSelectStudent: boolean = false;
    tournaments: Array<any> = [];

    constructor(
        private handlerService: HandlerService,
        private peopleService: PeopleService,
        private achievementsService: AchievementsService,
        private tournamentsService: TournamentsService,
        public dialog: MatDialog,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.studentsClassId = this.activatedRoute.snapshot.params['students_class_id'];
        if (this.studentsClassId) {
            this.getClass();
            localStorage.setItem('studentClassId', String(this.studentsClassId));
        }
        const reg =
            '(https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}' +
            '|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\\/\\/(?:www\\.|' +
            '(?!www))[a-zA-Z0-9]+\\.[^\\s]{2,}|www\\.[a-zA-Z0-9]+\\.[^\\s]{2,})';

        this.form = this.fb.group({
            date: [new Date(), []],
            award_event: ['', Validators.required],
            for_what: ['', Validators.required],
            comment: [''],
            url: ['', Validators.pattern(reg)],
            tournament: ['']
        });

        this.achievementsService.getAwardEvents().subscribe(resp => {
            if (!resp.error) {
                this.awardEvents = resp.data;
                this.form.patchValue({
                    award_event: this.awardEvents[0].id
                });
                this.getEventAwardCards();
            }
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    private getClassTournaments(): void {
        this.tournamentsService.getClassTournaments(this.selectedClass.title).subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.error) {
                this.tournaments = resp.data;
            }
        });
    }

    public getEventAwardCards(): void {
        const ev = +this.form.value.award_event;
        if (ev === this.TOURNAMENT_EVENT_ID) {
            this.getClassTournaments();
        }
        this.achievementsService.getEventAwardCards(ev).subscribe(
            resp => {
                this.handlerService.checkErrors(resp);
                console.log(resp);
                this.eventAwards = resp.data;
            },
            error => console.log(error)
        );
    }

    private getClass(): void {
        this.peopleService.getClass(this.studentsClassId).subscribe(resp => {
            this.selectedClass = resp;
            this.students = resp.students;
        });
    }

    private checkSelectStudent(): boolean {
        return this.students.some(item => item.select);
    }

    resetFormData(): void {
        this.selectedAllStudents = true;
        this.selectAllStudents();
        this.form.patchValue({
            for_what: '',
            comment: '',
            url: ''
        });
        this.filesLinks = [];
        this.choosesCard = null;
    }

    selectAllStudents(): void {
        this.selectedAllStudents = !this.selectedAllStudents;
        this.isSelectStudent = this.selectedAllStudents;
        this.students.forEach(item => {
            item.select = this.selectedAllStudents;
        });
    }

    selectStudent(student: Student): void {
        this.selectedAllStudents = false;
        student.select = !student.select;
        this.isSelectStudent = this.checkSelectStudent();
    }

    get countSelectStudents(): number {
        if (this.students) {
            return this.students.filter(it => it.select).length;
        }
        return 0;
    }

    chooseCard(award: BaseCard): void {
        this.choosesCard = award;
        if (this.choosesCard.for_what) {
            this.form.patchValue({
                for_what: this.choosesCard.for_what
            });
        }
    }

    addLink(): void {
        const link = this.form.value.url;
        if (link && this.form.controls.url.valid) {
            this.filesLinks.push(link);

            this.form.patchValue({
                url: ''
            });

            return;
        }
        this.handlerService.errorMsg('Неправильная ссылка');
    }

    deleteCurrentLink(): void {
        const link = this.form.value.url;
        const index = this.filesLinks.indexOf(link);

        if (index > -1) {
            this.filesLinks.splice(index, 1);
        }

        this.form.patchValue({
            url: ''
        });
    }

    showLink(link: string): void {
        this.form.patchValue({
            url: link
        });
    }

    onSubmit(): void {
        const formDate = this.form.value.date;
        const date = `${formDate.getFullYear()}-${formDate.getMonth() + 1}-${formDate.getDate()}`;
        const data = {
            event_id: this.form.value.award_event,
            comment: this.form.value.comment,
            urls: this.filesLinks,
            for_what: this.form.value.for_what,
            date,
            card_id: this.choosesCard ? this.choosesCard.id : null,
            students: [],
            special_data: {
                tournament_id: this.form.value.tournament
            }
        };

        this.students.forEach(item => {
            if (item.select) {
                data.students.push(item.id);
            }
        });

        this.achievementsService.addStudentsAwards(data).subscribe(
            resp => {
                this.handlerService.checkErrors(resp);
                if (resp.success) {
                    this.handlerService.successMsg('Награды успешно назначены');
                }
            },
            error => {
                console.log(error);
                this.handlerService.successMsg('Произошла ошибка попробуйте снова');
            }
        );

        this.resetFormData();
    }

    editUserAwards(student: Student): void {
        this.selectedStudent = student;
        this.isAwardSettings = false;
        this.isProfileAwards = true;
        this.isEditAward = false;
    }

    editAward(): void {
        this.isEditAward = true;
        this.isProfileAwards = false;
        this.isAwardSettings = false;
    }

    deleteAwardHandler() {
        this.isProfileAwards = true;
        this.isEditAward = false;
    }
}
